import {Navigate, Route, Routes, Outlet, useParams, useSearchParams} from 'react-router-dom'
import { DefaultTitle } from '../../../../_metronic/layout/components/header/page-title/DefaultTitle'
import {PageLink, PageTitle} from '../../../../_metronic/layout/core'
import { Article } from '../share-components/Article'
import { EmailConfirmation } from '../verification/EmailConfirmation'
import { ResetPassword } from '../verification/ResetPassword'
import { AboutUs } from './AboutUs'

const AboutPage = () => {

  var devBreadCrumbs: Array<PageLink> = [
    {
      title: 'หน้าหลัก',
      path: '/home',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const [queryParameters] = useSearchParams()
  
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route index element={<AboutUs />} />
      </Route>
    </Routes>
  )
}

export default AboutPage
